(function(args) { 

	var owlClassName = 'owl-carousel '+args.id;
	
	var carouselOptions = {
	    items:1,
	    nav:true,
	    loop:true,
	    autoplay:(args.attributes.autoplay) ? true : false,
	    autoplayTimeout:10000,
	    mouseDrag:false,
	    touchDrag: false,
	    autoHeight:true,
	    smartSpeed:800,
	    	    
	    onTranslate: function(event) {
	    
	    	jQuery('.owl-next, .owl-prev, .owl-dot').css('pointer-events', 'none');

		 	setTimeout(() => {
		      jQuery('.owl-next, .owl-prev, .owl-dot').css('pointer-events', 'auto');	      
		    }, 500);

		  }	
	}


	document.getElementById(args.id).innerHTML = `
		<div class="${owlClassName}">
			${args.items}
		</div>	 
	`;

	document.addEventListener('DOMContentLoaded', function() {
		
		const $carousel = jQuery('.' + args.id);

		$carousel.owlCarousel(carouselOptions);

		//fix
		$carousel.on('click', '.owl-prev, .owl-next, .owl-dot', function () {
			$carousel.find('.owl-item').find('.img-background').addClass('loaded');
		});

		$carousel.on('click', '.owl-prev, .owl-next, .owl-dot', function() { 
		  $carousel.trigger('stop.owl.autoplay');
		});

		$carousel.on('translate.owl.carousel', function() {
		  jQuery('.owl-item').css('pointer-events', 'none');
		  jQuery('.owl-item').css('user-select', 'none');
		});

		$carousel.on('translated.owl.carousel', function() {
		  jQuery('.owl-item').css('pointer-events', 'auto');
		  jQuery('.owl-item').css('user-select', 'auto');		  
		});

	});

})(args);